<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>Digital Literacy Program</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Academics</li>
                        <li>Digital Literacy Program</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <div class="academic-area pt-70">
            <div class="section-title">
                <h2>Unlock New Opportunities</h2>
                <p>Vedanta College offers five courses under Digital Literacy Program of National Institute of Electronics & Information Technology (NIELIT). NIELIT is an Autonomous Scientific Society under Ministry of Electronics & Information Technology (Meity), GoI.</p>
            </div>
        </div>

        <!--Start Alumni Area-->
        <div class="alumni-area pt-50 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="alumni-left-content">
                            <div class="single-alumni-events-card">
                                <div class="row align-items-center">
                                    <div class="col-lg-5 col-md-5">
                                        <div class="alumni-img">
                                            <img src="/vf/images/certification/dlc/10.png" alt="Image">
                                            <div class="date">
                                                <p>Certificate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-7">
                                        <div class="alumni-content">
                                            <div class="time">
                                                <p><i class="flaticon-time"></i><strong>Duration: </strong>20 hours</p>
                                            </div>
                                            <h3>ACC - Awareness Of Computer Concepts </h3>
                                            <div class="location">
                                                <p><i class="ri-money-cny-box-line"></i><strong>Syllabus </strong><a href="https://www.nielit.gov.in/sites/default/files/headquarter/pdf/ACC_Draft_Revised.pdf" target="_blank">Click here</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="single-alumni-events-card">
                                <div class="row align-items-center">
                                    <div class="col-lg-5 col-md-5">
                                        <div class="alumni-img">
                                            <img src="/vf/images/certification/dlc/9.png" alt="Image">
                                            <div class="date">
                                                <p>Certificate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-7">
                                        <div class="alumni-content">
                                            <div class="time">
                                                <p><i class="flaticon-time"></i><strong>Duration: </strong>36 hours</p>
                                            </div>
                                            <h3>BCC - Basic Computer Course</h3>
                                            <div class="location">
                                                <p><i class="ri-money-cny-box-line"></i><strong>Syllabus </strong><a href="https://www.nielit.gov.in/sites/default/files/headquarter/pdf/20190531_BCC_Revision.pdf" target="_blank">Click here</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="single-alumni-events-card">
                                <div class="row align-items-center">
                                    <div class="col-lg-5 col-md-5">
                                        <div class="alumni-img">
                                            <img src="/vf/images/certification/5.png" alt="Image">
                                            <div class="date">
                                                <p>Certificate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-7">
                                        <div class="alumni-content">
                                            <div class="time">
                                                <p><i class="flaticon-time"></i><strong>Duration: </strong>90 hours</p>
                                            </div>
                                            <h3>CCC - Course On Computer Course</h3>
                                            <div class="location">
                                                <p><i class="ri-money-cny-box-line"></i><strong>Syllabus </strong><a href="https://www.nielit.gov.in/sites/default/files/headquarter/pdf/20231006_CCC_Revised_Syllabus.pdf" target="_blank">Click here</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="alumni-right-content">
                            <div class="single-alumni-events-card">
                                <div class="row align-items-center">
                                    <div class="col-lg-5 col-md-5">
                                        <div class="alumni-img">
                                            <img src="/vf/images/certification/2.png" alt="Image">
                                            <div class="date">
                                                <p>Certificate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-7">
                                        <div class="alumni-content">
                                            <div class="time">
                                                <p><i class="flaticon-time"></i><strong>Duration: </strong>200 hours</p>
                                            </div>
                                            <h3>ECC - Expert Computer Course</h3>
                                            <div class="location">
                                                <p><i class="ri-money-cny-box-line"></i><strong>Syllabus </strong><a href="https://www.nielit.gov.in/sites/default/files/headquarter/education/pdf/160512_ECC_Details.pdf" target="_blank">Click here</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="single-alumni-events-card">
                                <div class="row align-items-center">
                                    <div class="col-lg-5 col-md-5">
                                        <div class="alumni-img">
                                            <img src="/vf/images/certification/7.png" alt="Image">
                                            <div class="date">
                                                <p>Certificate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-7">
                                        <div class="alumni-content">
                                            <div class="time">
                                                <p><i class="flaticon-time"></i><strong>Duration: </strong>126 hours</p>
                                            </div>
                                            <h3>CCC+ - Course On Computer Concepts Plus</h3>
                                            <div class="location">
                                                <p><i class="ri-money-cny-box-line"></i><strong>Syllabus </strong><a href="https://www.nielit.gov.in/sites/default/files/headquarter/education/pdf/160512_CCCPlus_Details.pdf" target="_blank">Click here</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Alumni Area-->

        <!-- Start Bottom Connect Area -->
        <div class="alumni-interview-area pb-100">
            <div class="container">
                <div class="interview-content ptb-100">
                    <div class="interview">
                        <router-link to="/academiccalender" class="default-btn btn">Academic Calender<i
                                class="flaticon-next"></i></router-link>
                        <router-link  to="/applynow" class="default-btn btn">Apply Now</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!--End Bottom Connect Area -->



</template>

<script>
export default {
    name : "VocationCenterView"
};
</script>
